/**
 * @description: Enum containing evey template name variable from '_fullscreen.scss' file
 */
export enum FullscreenLayoutTemplate {
    BASIC = 'basic',
    ONLY_MAIN = 'only-main',
    TEMPLATE_ONE = 'template-one',
    TEMPLATE_TWO = 'template-two',
    TEMPLATE_THREE = 'template-three',
    TEMPLATE_FOUR = 'template-four',
    TEMPLATE_FIVE = 'template-five',
}

/**
 * @description: Enum containing evey grid area name variable from '_fullscreen.scss' file
 */
export enum FullscreenLayoutAreas {
    MAIN = 'main',
    SIDECAR_MAIN = 'sidecar-main',
    SIDECAR_SECOND = 'sidecar-second',
    SIDECAR_THIRD = 'sidecar-third',
    SIDECAR_FOURTH = 'sidecar-fourth',
}

/**
 * @description: Object containing every template and its respective areas from '_fullscreen.scss' file
 */
export const layoutTemplatesAreas = {
    [FullscreenLayoutTemplate.ONLY_MAIN]: new Set([FullscreenLayoutAreas.MAIN]),
    [FullscreenLayoutTemplate.BASIC]: new Set([FullscreenLayoutAreas.MAIN, FullscreenLayoutAreas.SIDECAR_MAIN]),
    [FullscreenLayoutTemplate.TEMPLATE_ONE]: new Set([FullscreenLayoutAreas.MAIN, FullscreenLayoutAreas.SIDECAR_MAIN, FullscreenLayoutAreas.SIDECAR_SECOND]),
    [FullscreenLayoutTemplate.TEMPLATE_TWO]: new Set([FullscreenLayoutAreas.MAIN, FullscreenLayoutAreas.SIDECAR_MAIN, FullscreenLayoutAreas.SIDECAR_SECOND]),
    [FullscreenLayoutTemplate.TEMPLATE_THREE]: new Set([FullscreenLayoutAreas.MAIN, FullscreenLayoutAreas.SIDECAR_MAIN]),
};
// Left overs
// [FullscreenLayoutTemplate.TEMPLATE_FOUR]: new Set([FullscreenLayoutAreas.MAIN, FullscreenLayoutAreas.SIDECAR_MAIN, FullscreenLayoutAreas.SIDECAR_SECOND]),
// [FullscreenLayoutTemplate.TEMPLATE_FIVE]: new Set([FullscreenLayoutAreas.MAIN, FullscreenLayoutAreas.SIDECAR_MAIN, FullscreenLayoutAreas.SIDECAR_FOURTH]),
